import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGalleryAuto = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 47.958 31.939",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "gallery_thumbnail_FILL1_wght500_GRAD0_opsz48",
		d: "M42.263,324.352a3.814,3.814,0,0,1-3.85-3.85V296.25a3.819,3.819,0,0,1,3.85-3.837H66.515a3.824,3.824,0,0,1,3.837,3.837V320.5a3.819,3.819,0,0,1-3.837,3.85Zm32.644-17.02a2.422,2.422,0,0,1-2.454-2.454v-10.01a2.422,2.422,0,0,1,2.454-2.454h9.01a2.422,2.422,0,0,1,2.454,2.454v10.01a2.422,2.422,0,0,1-2.454,2.454ZM45.372,315.14h18.02l-5.913-7.884-4.223,5.631-3.111-4.111Zm29.535,9.212a2.422,2.422,0,0,1-2.454-2.454v-10.01a2.422,2.422,0,0,1,2.454-2.454h9.01a2.422,2.422,0,0,1,2.454,2.454V321.9a2.422,2.422,0,0,1-2.454,2.454Z",
		transform: "translate(-38.413 -292.413)"
	})
});
export default SvgGalleryAuto;
